$(function ($) {

  /*---------------- Responsive Menu ------------------*/
  $(".m-menu-btn").on('click', function (e) {
    $("body").toggleClass('off-canvas-body');
    $(".header-section").toggleClass("menu-open");
    $(this).toggleClass("m-menu-btn-ext");
    e.preventDefault();
  });
  $('nav.menu').on("click", ".has-submenu > a > span", function (e) {
    $(this).parent('a').next('.menu-dropdown').slideToggle(600);
    $(this).toggleClass('icon-down-arrow icon-up-arrow');
    e.stopPropagation();
    e.preventDefault();
  });
  /*$('nav.menu').on("click", ".has-multisubmenu > a > span", function (e) {
    $(this).parent('a').next('.menu-dropdown').slideToggle(600);
    $(this).toggleClass('icon-down-arrow icon-up-arrow');
    e.stopPropagation();
    e.preventDefault();
  });*/

  $(document).on('click touchstart', function(e) {
    if (!$(e.target).is('.m-menu-btn, .m-menu-btn , .header-section, .header-section *')) {
      $('.m-menu-btn, .header-section').removeClass('menu-open');
      if ($(".m-menu-btn").hasClass("m-menu-btn-ext")) {
        $(".m-menu-btn").removeClass("m-menu-btn-ext");
      }
    }

  });

  $(".search-item").on('click', function(e) {
    $(".header-section").toggleClass('search-active');
    e.preventDefault();
  });
  // close when click off of container
  $(document).on('click touchstart', function(e) {
    if (!$(e.target).is('.search-item, .search-item *, .header-section, .header-section *')) {
      $('.search-item, .header-section').removeClass('search-active');
    }
  });

  $(".filter-btn").click(function () {
    $(".sidebar-col").addClass("sidebar-open");
  });
  $(".close-btn").click(function () {
    $(".sidebar-col").removeClass("sidebar-open");
  });

  /* footer mobile Dropdown */ 

  $('.f-title').on("click", function(e) {
    if ($(this).hasClass('menushow')) {
      remove_styles();
      $(this).removeClass('menushow');
      $(this).next('ul').removeClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').removeClass('menushowtoggle');
      }
    } else {
      remove_styles();
      $(this).addClass('menushow');
      $(this).next('ul').addClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').addClass('menushowtoggle');
      }
    }
    e.stopPropagation();
    e.preventDefault();
  });

  function remove_styles() {
    $('.f-title').each(function() {
      $(this).removeClass('menushow');
      $(this).next('ul').removeClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').removeClass('menushowtoggle');
      }
    });
  }

  /* footer mobile Dropdown End*/ 


  $('.inner-content').on("click", ".sub-links span", function (e) {
    $(this).closest('li').find('.sub-nav').slideToggle(600);
    $(this).toggleClass('icon-minus icon-plus');
    e.stopPropagation();
    e.preventDefault();
  });  

  /*----------------side-barr ------------------*/
  $('.sidebar-content > .title').on("click", function (e) {
    $(this).next('.inner-content').slideToggle(600);
    $(this).toggleClass('open');
    e.stopPropagation();
    e.preventDefault();
  });

  /*Start: Mobile sidebar filters*/
  function filter_popup() {
    $('.mob-filter').magnificPopup({
      delegate: 'a',
      removalDelay: 500, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function () {
          this.st.mainClass = this.st.el.attr('data-effect');
        }
      },
      midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
    });
    $('.sidebar-sec').addClass('mfp-hide');
  }
  if ($(window).width() < 1025) {
    filter_popup();
    $('.mfp-content .sidebar-sec').removeClass('mfp-hide');
  }
  $(window).on('resize', function(){
    if ($(window).width() < 1025) {
      filter_popup();
      $('.mfp-content .sidebar-sec').removeClass('mfp-hide');
    }
    else {
      $('.sidebar-sec').removeClass('mfp-hide');
      $('.mfp-content .sidebar-sec').addClass('mfp-hide');
    }
  });


  /*---------------- main Banner ------------------*/
  $(".main-banner-slider").slick({
    autoplay: true,
    dots: true,
    adaptiveHeight: true,
    autoplaySpeed: 5000,
    arrows: false,
  });


  /* home blog slider */ 

  $('.home-blog-slider').slick({
    dots: false,
    arrows: false,
    autoplay: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },                 
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  /* home blog slider End*/ 

  /* Shop slider */ 
  $('.shop-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.shop-slider-nav'
  });
  $('.shop-slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.shop-slider',
    dots: false,
    arrows: true,
    infinite: false,
    focusOnSelect: true,
    vertical:true,
    verticalSwiping:true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },     
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          vertical:false
          // horizontal:true,


        }
      },
      { 
        breakpoint:768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical:false,
          verticalSwiping:false
        }
      },
      { 
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical:false
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical:false
        }
      }
    ]
  });

  /* Shop slider end*/ 

  /*related-slider*/  

  $('.related-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    focusOnSelect: true,
    horizontal:true,
    horizontalSwiping:true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical:false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical:false
        }
      },
      { 
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical:false
        }
      }

    ]
  });

  /* classes-event-slider */
  $('.classes-event-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    focusOnSelect: true,
    horizontal:true,
    horizontalSwiping:true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical:false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical:false
        }
      },
      { 
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical:false
        }
      }

    ]
  });

  /*sun-shield-slider*/
  $('.sun-shield-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    focusOnSelect: true,
    horizontal:true,
    horizontalSwiping:true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical:false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical:false
        }
      },
      { 
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical:false
        }
      }
    ]
  });
});
/*------ Main Function End -------*/ 


/*---------------- testimonial Slider ------------------*/
$('.testi-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1201,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 567,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


/*----- qty Start --------*/ 

jQuery(document).ready(function () { 
  $('.qty-btn.plus').click(function (e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $('input[name=' + fieldName + ']').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $('input[name=' + fieldName + ']').val(1);
    }
  });
  // This button will decrement the value till 0
  $(".qty-btn.minus").click(function (e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 1) {
      // Decrement one
      $('input[name=' + fieldName + ']').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $('input[name=' + fieldName + ']').val(1);
    }
  });
  
  function openTab(event, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    event.currentTarget.className += " active";
  }
});

/*----- qty End --------*/  

/*  equal height */
var maxHeight = 0;
$(".classes-event-inner h3").each(function () {
  if ($(this).height() > maxHeight) {
    maxHeight = $(this).height();
  }
});
$(".classes-event-inner h3").height(maxHeight);

/*----------------------*/


$(function ($) {
  /*************************************************************/
  $(document).ready(function() {
    if($('.home-blog-slider').length) {
      /*var blogRssData = [];
      $.ajax({ 
        type: 'GET',
        url: 'https://app.shopifyexpertz.com/ochsner-wellness-rss-feed/get-rss-feed.php',
        async: false, 
        cache: false, 
        dataType: 'json',
        success: function (json) {
          blogRssData = json;
        }
      });*/
      /*if(blogRssData != '') {
        if(blogRssData.articles.length > 0) {
          var getHtml = '';
          $(blogRssData.articles).each(function(a,b) {
            getHtml += '<div><div class="colgrid item home-blog-box"><div class="blog-item-box"><div class="products-item"><div class="prod-img"><a href="'+b.page_url+'"><img src="'+b.img+'" alt="" /></a></div></div><div class="products-text"><h2><a href="'+b.page_url+'">'+b.title+'</a></h2><ul class="list--inline article__meta-buttons"><li><a href="'+b.page_url+'" class="blog-read">Read More</a></li></ul></div></div></div></div>';
          });
          //console.log(getHtml);
          if($('.home-blog-slider').hasClass('slick-initialized')) {
            $('.home-blog-slider').slick("unslick");
          }
          $('.home-blog-slider').empty();
          $('.home-blog-slider').html(getHtml);
          $('.home-blog-slider').slick({
            dots: false,
            arrows: false,
            autoplay: true,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1600,
                settings: {
                  slidesToShow: 4
                }
              },

              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 3
                }
              },                 
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 567,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
          });
        }
      }*/
    }
  });
  /*************************************************************/

  /*---------------- EQUAL HEIGHT START ------------------*/
  $(window).on('load',function() {
    equalheight('.prod-title .pro-title');
    equalheight('.blog-main');
  });

  $(window).on('resize',function() {
    equalheight('.prod-title .pro-title');
    equalheight('.blog-main');
  });
  /*---------------- EQUAL HEIGHT END ------------------*/
});